import React from "react";
import "./style.css";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <Container>
        <Row className="footer-row">
          <Col md={4} sm={12} className="box">
            <p>
              Descubre fragancias únicas que resaltan tu personalidad. Body
              Splash femeninos con aromas dulces, elegantes y juveniles.
            </p>
          </Col>

          <Col md={3} sm={6} className="box">
            <h2>Contacto</h2>
            <ul>
              <li>📍 Santa cruz, Bolivia</li>
              <li>📱 WhatsApp: +591 77609821</li>
            </ul>
          </Col>

          <Col md={3} sm={12} className="box">
            <h2>Nuestras redes sociales</h2>
            <ul>
              <li>
                <div className="social">
                  <ion-icon name="logo-instagram"></ion-icon>
                  <ion-icon name="logo-facebook"></ion-icon>
                  <ion-icon name="logo-tiktok"></ion-icon>
                  <ion-icon name="logo-whatsapp"></ion-icon>
                </div>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
